import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ListWorkedExamples from '../../../../../list/ListWorkedExamples';
import DialogElementLevels from '../DialogElementLevels/DialogElementLevels';
import IconTooltipButton from '../../../../../button/IconTooltipButton';

const WorkedExamples = ({ isLoading, top = 250 }) => {
  const [modal, setModal] = useState(null);
  const workedExamples = useSelector((state) => state?.class?.unitOfLearning.workedExamples || []);
  return (
    <>
      <div
        className={['bg-background bottom-0 absolute z-20 overflow-auto border-t border-muted']}
        style={{ top: `calc(${top}px + 2rem)`, width: 'calc(200px - 0.5rem)' }}
      >
        <div className='pt-1 pb-2 pl-1 pr-2 flex flex-col gap-2'>
          {isLoading ? (
            Array.from({ length: 3 }).map((_, i) => (
              <Skeleton variant='rectangular' className='rounded' key={`log-loading-${i}`} height={100} />
            ))
          ) : workedExamples?.length > 0 ? (
            <ListWorkedExamples
              id='worked-examples-list-ul'
              workedExamples={workedExamples}
              maxHeight='130px'
              buttons={(example) => (
                <IconTooltipButton
                  title='Preview worked example'
                  icon='expand-alt'
                  onClick={() => setModal(example)}
                  style={{
                    width: 24,
                    height: 24,
                    color: 'curreetColor'
                  }}
                />
              )}
            />
          ) : (
            <Typography className='text-muted-foreground opacity-50 text-center pt-2'>
              You don't have any worked example yet
            </Typography>
          )}
        </div>
      </div>
      {modal && <DialogElementLevels open={!!modal} onClose={() => setModal(null)} formData={modal} element="worked-examples" />}
    </>
  );
};

export default WorkedExamples;
